import { useEffect } from 'react';

/**
 * Custom hook to set the page title dynamically
 * Automatically appends " | Kokki" suffix for consistent branding
 * @param title - The page-specific title (e.g., "Login", "Register")
 */
export const usePageTitle = (title: string) => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = `${title} | Kokki`;

        // Restore previous title on cleanup (optional, useful for SPAs)
        return () => {
            document.title = previousTitle;
        };
    }, [title]);
};

export default usePageTitle;
